// extracted by css-extract-rspack-plugin
export default {"root":"root-tcn0U","listItem":"listItem-_xxdx","item":"item-yd7Ps","heading":"heading-3lhUt","body":"body-2pa1e"};